import { ref } from 'vue'

import { DEFAULT_DELAY_TIME } from '@/config/constants'
import useLogger from '@/hooks/useLogger'

// hooks
const { logInfo } = useLogger()

const shouldValidate = ref(false)

export default function useValidation() {
  /**
   * Rejects if invalid after pending validators finished
   *
   * @param {VuelidateState} validator
   * @returns {Promise}
   */
  function pendingValidate(validator, _field = '$invalid') {
    return new Promise((resolve, reject) => {
      if (validator.$anyError || !validator.$pending) {
        return validator[_field] ? reject(validator) : resolve(validator)
      }
      const poll = setInterval(() => {
        if (!validator.$pending) {
          clearInterval(poll)
          return validator[_field] ? reject(validator) : resolve(validator)
        }
      }, DEFAULT_DELAY_TIME / 5)
    })
  }

  function turnOffValidation() {
    logInfo(['%cSHOULDVALIDATE SET TO FALSE', 'color: green'])
    shouldValidate.value = false
  }

  function turnOnValidation() {
    logInfo(['%cSHOULDVALIDATE SET TO TRUE', 'color: green'])
    shouldValidate.value = true
  }

  return {
    pendingValidate,
    shouldValidate,
    turnOffValidation,
    turnOnValidation,
  }
}
